import { useCallback } from 'react';

export default function useFAQNavigation() {
  return useCallback(() => {
    window.open('https://helpcenter.busybusy.io/en/', '_blank');
  }, []);
}
